// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"5e0910a7","697":"df724974","893":"c35a20d4"}[chunkId] + ".chunk.css";
};